export default {"src":"/_next/static/media/feature-1.fd118948.svg","height":185,"width":218};